import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild} from '@angular/core';
import L from 'leaflet';
import { DeviceService } from '../../../../services/device.service';
import {CoordinatesDto, DeviceDto} from '../../../../types/dtos/device.dto';


@Component({
  selector: 'app-dialog-map-coords-selector',
  imports: [],
  templateUrl: './dialog-map-coords-selector.html',
  styleUrl: './dialog-map-coords-selector.css',
})
export class DialogMapCoordsSelector implements AfterViewInit, OnDestroy {
  @ViewChild('mapSelectCoordsContainer', {static: true})
  public mapSelectCoordsContainer!: ElementRef<HTMLDivElement>;

  @Input()
  public coords: CoordinatesDto | null = null;
  public device?: DeviceDto;

  @Output()
  public coordsSelected: EventEmitter<CoordinatesDto | null> = new EventEmitter<CoordinatesDto | null>();

  private _map!: L.Map;
  private _resizeObserver!: ResizeObserver;
  private _marker?: L.CircleMarker;

  constructor(
    private readonly _deviceService: DeviceService
  ) {
  }

  public ngAfterViewInit(): void {
    this._map = L.map(this.mapSelectCoordsContainer.nativeElement, {
      center: [
        49.8153,
        6.1296,
      ],
      zoom: 9,
    });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap contributors',
    })
      .addTo(this._map);
    this._resizeObserver = new ResizeObserver(() => {
      this._map.invalidateSize();
    });
    this._resizeObserver.observe(this.mapSelectCoordsContainer.nativeElement);
    if (this.coords) {
      this._updateMap(this.coords);
    }
    this._map.on('click', (e: L.LeafletMouseEvent) => {
      const coords: CoordinatesDto = {
        latitude: e.latlng.lat,
        longitude: e.latlng.lng
      }
      this.coordsSelected.emit(coords);
    });
  }

  public setCoords(coords: CoordinatesDto | null): void {
    this.coords = coords;
    this._updateMap(coords);
  }

  public ngOnDestroy(): void {
    this._resizeObserver.disconnect();
    this._map.remove();
  }

  private _updateMap(coords: CoordinatesDto | null): void {
    if (!this._map) return;
    const hasCoords: boolean = !!(coords?.latitude && coords?.longitude);

    let center: [number, number] = [49.8153, 6.1296];
    if (!hasCoords) {
      center = this._deviceService.getCenter()
    }

    const lat: number = coords?.latitude || center[0];
    const lng: number = coords?.longitude || center[1];
    this._map.setView([lat, lng], 13);
    if (this._marker) {
      this._marker.remove();
    }
    if (hasCoords) {
      this._marker = L.circleMarker([lat, lng], {
        radius: 8,
        fillColor: '#3b82f6',
        fillOpacity: 0.9,
        weight: 2,
      }).addTo(this._map);
    }
    this._map.invalidateSize();
  }
}
